import { FlexContainer } from 'features/common/components/FlexContainer';
import { InputLabel } from '../InputLabel';
import { InputToggleProps } from '../types';
import { PunchupToggle } from '../../PunchupToggle';
import { useFormContext } from 'react-hook-form';
import { useTheme } from 'styled-components';

export const PunchupInputToggle = ({ name, ...rest }: InputToggleProps) => {
	const { watch, setValue } = useFormContext();
	const theme = useTheme();
	const toggleValue = watch(name);

	return (
		<FlexContainer justifyContent="space-between" alignItems="center" margin="8px 0 0 0" width="100%">
			<InputLabel {...rest} color={theme.colors.black6} />
			<PunchupToggle isChecked={toggleValue} handleClick={() => setValue(name, !toggleValue)} name={name} />
		</FlexContainer>
	);
};
